import { useDispatch, useSelector } from 'umi';
import { TIMEHASDATA_NAMESPACE, getTypeMsg } from '@/pages/intelligence/models/filterTimeHasData';
import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { componentDefault as commonComponentDefault } from '@intelligence/components/Filter/FilterBase/FilterList';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import { getDefulatTimeValue } from '@/pages/intelligence/utils/common';
import { getQueryDefinition } from '@intelligence/services/common';

/**
 * 获取最早时间文档思路：
 * 1.通过model去调接口，并存储页面接口返回的时间:可搜索字段TIMEHASDATA_NAMESPACE
 * 2.filterType参数对应hasDataTimerParams里的key对应的type值
 * 3.通过filterType传入getTypeMsg函数，得到对应model的state,get,save名
 * 4.通过dispatch获取接口有数据的数据，放到latestTimeTypeHasData传到外面使用
 */

export default function useEarliesTimeHasData(props: {
  filterType?: string;
  rangeTimeType?: FilterTimeType;
  isUseCond?: boolean;
}) {
  const {
    filterType = '',
    rangeTimeType = FilterTimeType.commonRange,
    isUseCond = false,
  } = props || {};

  const dispatch = useDispatch();

  // @ts-ignore
  const modelState = useSelector((state) => state[TIMEHASDATA_NAMESPACE]);

  const modelMsg = useMemo(() => {
    const typeMsg = getTypeMsg(filterType);
    return {
      modelName: modelState?.[typeMsg.state],
      dispatchType: `${TIMEHASDATA_NAMESPACE}/${typeMsg.get}`,
      payload: hasDataTimerParams?.[filterType]?.params || {},
    };
  }, [filterType]);

  // 切换日周月，展示最近有数据的日期
  const [latestTimeTypeHasData, setLatestTimeTypeHasData] = useState<any>(null);
  const [filterLoading, setFilterLoding] = useState(true);

  const formatTimeRageDefaultData = (dateList: any[]) => {
    // 页面自定义的默认切换没有则用全局默认的
    const componentDefault =
      hasDataTimerParams?.[filterType]?.componentDefault ?? commonComponentDefault;
    const isSameDay = rangeTimeType === FilterTimeType.sameDay;
    const isSameMonth = rangeTimeType === FilterTimeType.sameMonth;
    let day = isSameDay
      ? [componentDefault.date[1], componentDefault.date[1]]
      : componentDefault.date;
    let { week } = componentDefault;
    let month = isSameMonth
      ? [componentDefault.month[1], componentDefault.month[1]]
      : componentDefault.month;
    let { year } = componentDefault;

    if (Array.isArray(dateList) && dateList?.length > 0) {
      dateList?.forEach((item: any) => {
        if (item.date_type == 'monthly') {
          month = [moment(isSameMonth ? item.end_date : item.start_date), moment(item.end_date)];
        } else if (item.date_type == 'weekly') {
          week = [moment(item.start_date), moment(item.end_date)];
        } else if (item.date_type == 'daily') {
          day = [moment(isSameDay ? item.end_date : item.start_date), moment(item.end_date)];
        } else if (item.date_type == 'yearly') {
          year = [moment(item.start_date), moment(item.end_date)];
        }
      });
    }

    return {
      date: day,
      week,
      month,
      year,
    };
  };

  const getTimeHasDataApiData = async (modelMsg: any) => {
    const { modelName, dispatchType, payload } = modelMsg;
    if (modelName.loading === false && modelName.data === null) {
      try {
        setFilterLoding(true);
        let res = {} as any;
        let dateList = [];
        if (isUseCond) {
          const condRes = await getQueryDefinition({
            combineMetricTableDefaultDataByDate: {
              target: 'get_default_data_by_date',
              params: payload,
            },
          });
          dateList = condRes?.data?.combineMetricTableDefaultDataByDate || [];
        } else {
          res = await dispatch({
            type: dispatchType,
            payload,
          });
          dateList = res?.data || [];
        }
        const dateListValue = getDefulatTimeValue(dateList);
        // 调接口的值
        setLatestTimeTypeHasData(formatTimeRageDefaultData(dateListValue));

        setFilterLoding(false);
      } catch (err) {
        setFilterLoding(false);
      }
    } else {
      setFilterLoding(false);
      const dateListValue = getDefulatTimeValue(modelName?.data?.data);
      // 调缓存的值
      setLatestTimeTypeHasData(formatTimeRageDefaultData(dateListValue));
    }
  };

  useEffect(() => {
    if (modelMsg?.modelName?.loading === false) {
      getTimeHasDataApiData(modelMsg);
    }
  }, [modelMsg?.modelName?.loading]);

  return {
    filterLoading,
    latestTimeTypeHasData,
  };
}
